import React from "react";
import { useTranslation } from "react-i18next";
import { CardEmptyState } from "../../EmptyState";

const LastApplicationNoteTakenNotFound: React.FC = () => {
	const { t } = useTranslation();

	return (
		<CardEmptyState
			icon={<></>}
			title={""}
			message={t("freelancerDetails.lastExchange.noNotesMessage")}
			cardTitle={t("freelancerDetails.lastExchange.title")}
			titleVariant="body1"
			hideIcon={true}
		/>
	);
};

export default LastApplicationNoteTakenNotFound;
